// =============================================================================
// MÜLAKAT HAZIRLIK MERKEZİ - YENİ İÇERİKLER
// =============================================================================
// Havayolu mülakatlarına profesyonel hazırlık içerikleri
// =============================================================================

export const interviewContents = {
  
  // =============================================================================
  // MODÜL 1: MÜLAKAT TEMELLERİ
  // =============================================================================
  
  'INT-M1-U1-L1': {
    lesson_id: 'INT-M1-U1-L1',
    title: 'Mülakat Süreci Nasıl İşler?',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '📋 Havayolu Mülakat Süreci',
      paragraphs: [
        'Havayolu mülakatları genellikle 4-5 aşamadan oluşur ve her aşamada farklı yetkinlikler değerlendirilir. Bu süreci iyi anlamak, başarı şansınızı önemli ölçüde artırır.',
        'İlk aşama genellikle online başvuru ve CV taramasıdır. CV\'nizin havacılık sektörüne uygun olması, anahtar kelimeleri içermesi kritik önem taşır.',
        'İkinci aşama çoğu havayolunda online İngilizce sınavı veya video mülakatıdır. THY\'de 5 soruluk video mülakat, Pegasus\'ta online testler uygulanır.',
        'Üçüncü aşama fiziksel değerlendirmedir: boy-kilo oranı (BMI), dövme kontrolü, genel görünüm. Bu aşamada kriterlere uymayan adaylara süre verilebilir.',
        'Son aşama yüz yüze kurul mülakatıdır. İK uzmanı, kabin amiri ve bazen psikolog bulunur. Bu aşamada iletişim, problem çözme ve takım becerileri değerlendirilir.'
      ],
      keyPoints: [
        'Her havayolunun kendine özgü süreci vardır - araştırın',
        'Online aşamalarda teknik altyapınızı test edin',
        'Fiziksel kriterler değişebilir - ilan şartlarını kontrol edin',
        'Süreç 2-6 hafta sürebilir - sabırlı olun'
      ]
    }
  },

  'INT-M1-U1-L2': {
    lesson_id: 'INT-M1-U1-L2',
    title: 'Online Video Mülakat',
    type: 'interactive',
    duration: 4,
    xp: 35,
    content: {
      title: '🎥 Video Mülakat Hazırlık',
      intro: 'Video mülakatlar artık standart. THY dahil birçok havayolu bu yöntemi kullanıyor. Her soruya belirli sürede cevap vermeniz gerekiyor.',
      challenge: {
        type: 'multipleChoice',
        question: 'Video mülakatta en önemli faktör nedir?',
        options: [
          { text: 'Çok hızlı konuşmak', isCorrect: false, feedback: '❌ Hızlı konuşmak anlaşılamamanıza neden olur' },
          { text: 'Kameraya bakarak doğal konuşmak', isCorrect: true, feedback: '✅ Göz teması ve doğallık kritik!' },
          { text: 'Ezbere cevap vermek', isCorrect: false, feedback: '❌ Ezber yapay görünür, samimiyeti kırar' },
          { text: 'Arka planı süslemek', isCorrect: false, feedback: '❌ Sade, düzenli arka plan yeterli' }
        ]
      },
      facts: [
        { icon: '💡', title: 'İpucu 1', text: 'Kamerayı göz hizasına yerleştirin' },
        { icon: '🔊', title: 'İpucu 2', text: 'Sessiz ortam, iyi aydınlatma şart' },
        { icon: '👔', title: 'İpucu 3', text: 'Üst beden tam mülakat kıyafeti giyin' },
        { icon: '⏱️', title: 'İpucu 4', text: 'Cevap süresi genelde 60-90 saniye' }
      ]
    }
  },

  'INT-M1-U2-L1': {
    lesson_id: 'INT-M1-U2-L1',
    title: 'CV Hazırlama Rehberi',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '📄 Havacılık CV\'si Nasıl Olmalı?',
      paragraphs: [
        'Havayolu CV\'si diğer sektörlerden farklıdır. Profesyonel fotoğraf ZORUNLUDUR. Fotoğraf: düz arka plan, gülümseyen, profesyonel kıyafet.',
        'CV tek sayfa olmalı, net ve öz yazılmalıdır. Font: Arial veya Calibri, 11-12 punto. Renkli tasarımlardan kaçının.',
        'Deneyim bölümünde MÜŞTERİ HİZMETLERİ deneyimlerini öne çıkarın. Restoran, otel, satış, turizm deneyimleri çok değerli.',
        'Dil becerileri önemli: İngilizce seviyenizi (A1-C2) ve varsa diğer dilleri belirtin. TOEIC, IELTS gibi sertifikalar artı puan.',
        'İlgi alanları kısmında SPOR ve SOSYAL AKTİVİTELER yazın. Takım sporları, dans, yüzme gibi aktiviteler ekip uyumunu gösterir.'
      ],
      keyPoints: [
        'Profesyonel vesikalık fotoğraf şart',
        'Maksimum 1 sayfa, 2 sayfa kabul edilmez',
        'Müşteri hizmetleri deneyimlerini vurgulayın',
        'Takım sporları ve sosyal aktiviteleri ekleyin'
      ]
    }
  },

  'INT-M1-U3-L1': {
    lesson_id: 'INT-M1-U3-L1',
    title: 'Giyim Kuşam Rehberi - Kadın',
    type: 'lesson',
    duration: 4,
    xp: 25,
    content: {
      title: '👗 Kadın Adaylar İçin Giyim',
      paragraphs: [
        'Mülakat giyimi = Uçakta görev yapıyormuş gibi görünmek. Kabin memuru imajı oluşturmalısınız.',
        'TAKIM ELBİSE: Lacivert, siyah veya gri blazer ceket + diz hizası veya altı etek. Pantolon da kabul edilir ama etek tercih edilir.',
        'GÖMLEK: Beyaz veya açık mavi gömlek. Düğmeler kapalı, yaka düzgün. Derin dekolte KESİNLİKLE yasak.',
        'AYAKKABI: Siyah veya lacivert topuklu (5-7 cm). Çok yüksek topuk veya düz ayakkabı uygun değil. Temiz ve cilalı olmalı.',
        'SAÇ: Topuz veya at kuyruğu. Yüz açık olmalı. Doğal saç rengi tercih edilir. Aşırı boyalı saç dikkat çeker.',
        'MAKYAJ: Doğal görünüm. Kırmızı veya nude ruj, hafif göz makyajı. Aşırı makyaj kaçınılması gereken bir hata.'
      ],
      keyPoints: [
        'Lacivert veya siyah takım tercih edin',
        'Saçlar toplu, yüz açık olmalı',
        'Doğal makyaj, kırmızı veya nude ruj',
        '5-7 cm topuklu, temiz ayakkabı'
      ]
    }
  },

  'INT-M1-U3-L2': {
    lesson_id: 'INT-M1-U3-L2',
    title: 'Giyim Kuşam Rehberi - Erkek',
    type: 'lesson',
    duration: 4,
    xp: 25,
    content: {
      title: '👔 Erkek Adaylar İçin Giyim',
      paragraphs: [
        'Erkek adaylar için klasik takım elbise şarttır. Gündelik kıyafet veya smart casual kabul edilmez.',
        'TAKIM ELBİSE: Lacivert veya koyu gri tercih edilmeli. Siyah da kabul edilir. Takım ütülü ve fit kesim olmalı.',
        'GÖMLEK: Beyaz veya açık mavi uzun kollu gömlek. Kollar kesinlikle kıvrılmaz. Düğmeler kapalı, kravat şart.',
        'KRAVAT: Düz renk veya hafif desenli. Kırmızı, lacivert veya bordo tercih edilebilir. Çok parlak veya çizgili kravatlardan kaçının.',
        'AYAKKABI: Siyah veya koyu kahve klasik ayakkabı. Spor ayakkabı, loafer kabul edilmez. Ayakkabılar cilalı olmalı.',
        'SAÇ ve SAKAL: Saçlar kısa ve taranmış olmalı. Sakal varsa düzgün kesilmiş olmalı, uzun sakal uygun değil.'
      ],
      keyPoints: [
        'Lacivert veya koyu gri takım elbise',
        'Beyaz gömlek ve kravat zorunlu',
        'Klasik siyah ayakkabı, cilalı',
        'Saç kısa ve düzenli, sakal bakımlı'
      ]
    }
  },

  'INT-M1-U4-L1': {
    lesson_id: 'INT-M1-U4-L1',
    title: 'Beden Dili ve Duruş',
    type: 'interactive',
    duration: 4,
    xp: 35,
    content: {
      title: '🧍 Profesyonel Beden Dili',
      intro: 'İletişimin %55\'i beden dilinden oluşur. Mülakatta söyledikleriniz kadar nasıl göründüğünüz de önemli.',
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakatta en uygun oturma pozisyonu hangisi?',
        options: [
          { text: 'Arkaya yaslanmak', isCorrect: false, feedback: '❌ Umursamaz ve ilgisiz görünürsünüz' },
          { text: 'Kolları kavuşturmak', isCorrect: false, feedback: '❌ Savunmacı ve kapalı görünürsünüz' },
          { text: 'Hafif öne eğilerek, dik oturmak', isCorrect: true, feedback: '✅ İlgili ve özgüvenli görünürsünüz' },
          { text: 'Bacak bacak üstüne atmak', isCorrect: false, feedback: '❌ Rahat ama profesyonel değil' }
        ]
      },
      facts: [
        { icon: '👁️', title: 'Göz Teması', text: 'Konuşurken %60-70 göz teması kurun' },
        { icon: '🙂', title: 'Gülümseme', text: 'Doğal gülümseme güven verir' },
        { icon: '🤝', title: 'El Sıkışma', text: 'Kararlı ama ezmeden el sıkın' },
        { icon: '🚶', title: 'Yürüyüş', text: 'Dik ve kendinden emin yürüyün' }
      ]
    }
  },

  'INT-M1-U4-L2': {
    lesson_id: 'INT-M1-U4-L2',
    title: 'Beden Dili Senaryoları',
    type: 'scenario',
    duration: 3,
    xp: 30,
    scenario: {
      context: 'Mülakat odasına girdiniz. Jüri sizi karşılıyor.',
      question: 'İlk izlenimi oluşturmak için ne yapmalısınız?',
      options: [
        { id: 'A', text: 'Hızlıca yerime oturup bekliyorum', isCorrect: false },
        { id: 'B', text: 'Gülümseyerek selam verip, el sıkışma teklif ediyorum', isCorrect: true },
        { id: 'C', text: 'Başımla selam verip sessizce oturuyorum', isCorrect: false },
        { id: 'D', text: 'Jüri oturmasını söyleyene kadar ayakta duruyorum', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Mükemmel! İlk izlenim kritik. Gülümseme + göz teması + el sıkışma = profesyonellik.',
        wrong: '❌ İlk izlenim çok önemli. Aktif ve güler yüzlü bir giriş yapmalısınız.'
      },
      explanation: 'İlk 7 saniyede izlenim oluşur. Gülümseyin, göz teması kurun ve kendinden emin olun.'
    }
  },

  // =============================================================================
  // MODÜL 2: GRUP MÜLAKATİ TEKNİKLERİ
  // =============================================================================

  'INT-M2-U1-L1': {
    lesson_id: 'INT-M2-U1-L1',
    title: 'Grup Mülakatı Nedir?',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '👥 Grup Mülakatını Anlamak',
      paragraphs: [
        'Grup mülakatı, 6-12 adayın aynı anda değerlendirildiği bir formattır. Havayolları bu formatı TAKIM UYUMUNU test etmek için kullanır.',
        'Grup mülakatında rakipleriniz değil, POTANSİYEL EKİP ARKADAŞLARINIZ var. Bunu unutmayın!',
        'Jüri şunları gözlemler: Kim söz kesiyor? Kim dinliyor? Kim uzlaşma sağlıyor? Kim liderlik yapıyor?',
        'Aşırı baskın olmak KÖTÜ puandır. Havacılıkta tek başına kahraman yoktur, TAKIM vardır.',
        'Sessiz kalmak da KÖTÜ puandır. Fikrinizi söylemezseniz değerlendirilemezsiniz.'
      ],
      keyPoints: [
        'Rakip değil, potansiyel ekip arkadaşı',
        'Aşırı baskın = eleme riski',
        'Sessiz kalmak = değerlendirilememe',
        'Dengeli katılım hedefleyin'
      ]
    }
  },

  'INT-M2-U1-L2': {
    lesson_id: 'INT-M2-U1-L2',
    title: 'Grup Dinamikleri',
    type: 'interactive',
    duration: 4,
    xp: 35,
    content: {
      title: '⚖️ Dengeli Katılım Stratejisi',
      intro: 'Grup mülakatında başarı = doğru zamanda doğru katkı. Hem konuşmalı hem dinlemelisiniz.',
      challenge: {
        type: 'multipleChoice',
        question: 'Grup tartışmasında bir aday sürekli sözünüzü kesiyor. Ne yaparsınız?',
        options: [
          { text: 'Onunla tartışmaya giriyorum', isCorrect: false, feedback: '❌ Çatışma olumsuz izlenim yaratır' },
          { text: 'Sessiz kalıyorum, bırakıyorum', isCorrect: false, feedback: '❌ Pasif kalmak da iyi değil' },
          { text: '"Bitirmemi bekler misin?" diyip sakin devam ediyorum', isCorrect: true, feedback: '✅ Profesyonel ve kararlı yaklaşım' },
          { text: 'Jüriye şikayet ediyorum', isCorrect: false, feedback: '❌ Bu çok yanlış bir tercih olur' }
        ]
      },
      facts: [
        { icon: '📊', title: 'İdeal Oran', text: '%40 konuşma, %60 dinleme' },
        { icon: '🔄', title: 'Dahil Etme', text: 'Sessiz kalan adayları dahil edin' },
        { icon: '✅', title: 'Onaylama', text: '"İyi fikir" diyerek başkalarını destekleyin' },
        { icon: '🎯', title: 'Özetleme', text: 'Tartışmayı özetlemek liderlik gösterir' }
      ]
    }
  },

  'INT-M2-U2-L1': {
    lesson_id: 'INT-M2-U2-L1',
    title: 'Takım Oyunları',
    type: 'lesson',
    duration: 5,
    xp: 35,
    content: {
      title: '🎮 Grup Aktiviteleri',
      paragraphs: [
        'Havayolu mülakatlarında sık kullanılan aktiviteler: Tartışma, problem çözme, sunum ve rol yapma.',
        'TARTIŞMA: "Ada senaryosu" - 10 nesneden 5 tanesini seçin. Burada UZLAŞMA becerisi test edilir.',
        'PROBLEM ÇÖZME: "Uçuş gecikmesi" - Yolculara nasıl açıklarsınız? ÇÖZÜM ODAKLILIK test edilir.',
        'SUNUM: "Şirketinizi tanıtın" - Ekip olarak 5 dakikada sunum hazırlayın. ORGANZASYON test edilir.',
        'ROL YAPMA: "Kızgın yolcu" - Sakinleştirme ve empati becerisi test edilir.'
      ],
      keyPoints: [
        'Her aktivitede farklı beceri test edilir',
        'Sonuç kadar SÜREÇ de değerlendirilir',
        'Ekip başarısı bireysel başarıdan önemli',
        'Herkesin katkısını sağlayın'
      ]
    }
  },

  'INT-M2-U2-L2': {
    lesson_id: 'INT-M2-U2-L2',
    title: 'Ada Senaryosu Simülasyonu',
    type: 'scenario',
    duration: 5,
    xp: 40,
    scenario: {
      context: 'Grup mülakatındasınız. Jüri diyor ki: "Issız bir adaya düştünüz. 10 nesne var, sadece 5 tanesini alabilirsiniz. Ekip olarak karar verin."',
      question: 'Bu aktivitede en önemli strateji nedir?',
      options: [
        { id: 'A', text: 'En çok konuşarak fikrimi kabul ettirmek', isCorrect: false },
        { id: 'B', text: 'Mantıklı gerekçeler sunup ekibi dinlemek', isCorrect: true },
        { id: 'C', text: 'Sessiz kalıp çoğunluğa uymak', isCorrect: false },
        { id: 'D', text: 'İlk konuşup lider olmak', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Doğru! Fikrinizi GEREKÇELİ sunun, ama UZLAŞMAYA açık olun. Jüri mantığınızı ve takım uyumunuzu test ediyor.',
        wrong: '❌ Bu aktivitede önemli olan KİM KAZANDI değil, NASIL KARAR VERİLDİ. Ekip uyumu ve mantıklı tartışma önemli.'
      },
      explanation: 'Bu tür aktivitelerde doğru cevap yoktur. Jüri sürecinizi değerlendirir: iletişim, empati, mantık, uzlaşma.'
    }
  },

  'INT-M2-U3-L1': {
    lesson_id: 'INT-M2-U3-L1',
    title: 'Öne Çıkma Stratejileri',
    type: 'interactive',
    duration: 4,
    xp: 35,
    content: {
      title: '⭐ Olumlu Şekilde Fark Edilmek',
      intro: 'Grup içinde fark edilmek önemli ama DOĞRU ŞEKILDE fark edilmelisiniz.',
      challenge: {
        type: 'multipleChoice',
        question: 'Grupta olumlu fark edilmenin en iyi yolu?',
        options: [
          { text: 'En çok konuşmak', isCorrect: false, feedback: '❌ Çok konuşmak baskıcı görünür' },
          { text: 'Farklı giyinmek', isCorrect: false, feedback: '❌ Dikkat çeker ama olumlu değil' },
          { text: 'Yapıcı katkılar sunmak ve başkalarını dahil etmek', isCorrect: true, feedback: '✅ Liderlik ve takım ruhu gösterir' },
          { text: 'Jüriye sürekli gülümsemek', isCorrect: false, feedback: '❌ Yapay görünür' }
        ]
      },
      facts: [
        { icon: '🎯', title: 'Yapıcı Ol', text: '"Evet ve..." ile başla, "Hayır ama..." değil' },
        { icon: '🤝', title: 'Dahil Et', text: '"X ne düşünüyor?" diye sor' },
        { icon: '📝', title: 'Özetle', text: '"Özetlersek..." diyerek netleştir' },
        { icon: '👏', title: 'Takdir Et', text: '"Güzel fikir" diyerek destekle' }
      ]
    }
  },

  // =============================================================================
  // MODÜL 3: BİREBİR MÜLAKAT HAZIRLIK
  // =============================================================================

  'INT-M3-U1-L1': {
    lesson_id: 'INT-M3-U1-L1',
    title: 'Birebir Mülakat Yapısı',
    type: 'lesson',
    duration: 5,
    xp: 30,
    content: {
      title: '🎯 Birebir Mülakat',
      paragraphs: [
        'Birebir mülakat, jüri ile yüz yüze yapılan değerlendirmedir. Genellikle 20-45 dakika sürer.',
        'Jüri genellikle 2-3 kişiden oluşur: İK uzmanı, kabin amiri/şefi ve bazen psikolog.',
        'Sorular 3 kategoride gelir: KİŞİSEL (kendinizi tanıtın), DAVRANIŞSAL (geçmiş deneyimler), DURUMSAL (senaryo sorular).',
        'Her soru için STAR tekniği kullanın: Situation (Durum), Task (Görev), Action (Eylem), Result (Sonuç).',
        'Mülakat sonunda size soru sorma hakkı tanınır. "Sorularınız var mı?" sorusuna HER ZAMAN soru hazırlayın.'
      ],
      keyPoints: [
        '20-45 dakika sürer, her dakika önemli',
        'STAR tekniği ile yapılandırılmış cevaplar',
        'Somut örnekler ve rakamlar kullanın',
        'Sona soru hazırlayın'
      ]
    }
  },

  'INT-M3-U1-L2': {
    lesson_id: 'INT-M3-U1-L2',
    title: 'STAR Tekniği',
    type: 'interactive',
    duration: 5,
    xp: 40,
    content: {
      title: '⭐ STAR Tekniği Nedir?',
      intro: 'STAR, davranışsal sorulara yapılandırılmış cevap verme yöntemidir. Her havayolu mülakatında kullanın.',
      challenge: {
        type: 'multipleChoice',
        question: '"Zor bir müşteriyle nasıl başa çıktınız?" sorusuna STAR ile başlarken ilk adım ne?',
        options: [
          { text: 'Hemen çözümü anlatmak', isCorrect: false, feedback: '❌ Önce durumu açıklamalısınız' },
          { text: 'Durumu ve bağlamı açıklamak', isCorrect: true, feedback: '✅ S = Situation. Önce sahneyi kurun.' },
          { text: 'Sonucu söylemek', isCorrect: false, feedback: '❌ Sonuç en sonda gelir' },
          { text: 'Görevinizi anlatmak', isCorrect: false, feedback: '❌ Görev ikinci adım' }
        ]
      },
      facts: [
        { icon: '📍', title: 'S - Situation', text: 'Nerede? Ne zaman? Kim vardı?' },
        { icon: '🎯', title: 'T - Task', text: 'Göreviniz neydi? Problem ne?' },
        { icon: '⚡', title: 'A - Action', text: 'Siz ne yaptınız? Hangi adımlar?' },
        { icon: '🏆', title: 'R - Result', text: 'Sonuç ne oldu? Ne öğrendiniz?' }
      ]
    }
  },

  'INT-M3-U2-L1': {
    lesson_id: 'INT-M3-U2-L1',
    title: 'Kendinizi Tanıtın',
    type: 'lesson',
    duration: 5,
    xp: 35,
    content: {
      title: '👋 "Tell Me About Yourself"',
      paragraphs: [
        'Bu soru %99 mülakatta sorulur. 60-90 saniye içinde kendinizi tanıtmalısınız. Ezbere değil, doğal konuşun.',
        'YAPISI: Şu an + Geçmiş + Gelecek. "Şu anda X\'te çalışıyorum. Y\'de eğitim aldım. Kabin memuru olmak istiyorum çünkü..."',
        'YAPMAYIN: CV\'nizi baştan sona okumayın. Çok kişisel bilgi (evlilik, çocuk, din) paylaşmayın.',
        'YAPIN: Müşteri hizmetleri deneyiminizi vurgulayın. Takım çalışması örnekleri verin. Havacılık tutkusunu gösterin.',
        'İNGİLİZCE: "My name is... I have been working at... for X years. I am passionate about aviation because..."'
      ],
      keyPoints: [
        '60-90 saniye, fazla uzatmayın',
        'Şu an + Geçmiş + Gelecek yapısı',
        'Müşteri hizmetleri vurgulayın',
        'Havacılık tutkusu gösterin'
      ]
    }
  },

  'INT-M3-U2-L2': {
    lesson_id: 'INT-M3-U2-L2',
    title: 'Zor Sorular',
    type: 'scenario',
    duration: 4,
    xp: 40,
    scenario: {
      context: 'Jüri soruyor: "En büyük zayıf yönünüz nedir?"',
      question: 'En iyi cevap stratejisi nedir?',
      options: [
        { id: 'A', text: '"Zayıf yönüm yok" demek', isCorrect: false },
        { id: 'B', text: 'Gerçek bir zayıflık + nasıl geliştirdiğiniz', isCorrect: true },
        { id: 'C', text: '"Çok mükemmeliyetçiyim" demek', isCorrect: false },
        { id: 'D', text: 'Havacılıkla ilgisiz bir şey söylemek', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Doğru! Örnek: "Bazen çok detaycı olabiliyorum ama zaman yönetimi teknikleri öğrenerek bunu dengelemeyi başardım."',
        wrong: '❌ "Zayıf yönüm yok" kibirli, "mükemmeliyetçiyim" klişe. Gerçek ve GELİŞTİRİLMİŞ bir örnek verin.'
      },
      explanation: 'Bu soru öz farkındalık ve gelişim kapasitesi test eder. Dürüst olun ama çözümü de gösterin.'
    }
  },

  'INT-M3-U3-L1': {
    lesson_id: 'INT-M3-U3-L1',
    title: 'Sık Sorulan Sorular',
    type: 'quiz',
    duration: 6,
    xp: 50,
    quiz: {
      questions: [
        {
          q: '"Neden kabin memuru olmak istiyorsunuz?" sorusuna en iyi cevap?',
          options: [
            'Dünyayı gezmek istiyorum',
            'Yolcu güvenliği ve hizmeti benim için önemli',
            'İyi maaş ve tatil günleri',
            'Arkadaşım kabin memuru, güzel iş'
          ],
          correct: 1
        },
        {
          q: '"Neden şirketimizi seçtiniz?" için en kötü cevap?',
          options: [
            'Şirketinizin değerlerini paylaşıyorum',
            'Global ağınız etkileyici',
            'Başvurduğum tek yer buraydı',
            'Eğitim programınız kapsamlı'
          ],
          correct: 2
        },
        {
          q: '"5 yıl sonra kendinizi nerede görüyorsunuz?" için ideal cevap?',
          options: [
            'Başka şirkette pilot',
            'Bu şirkette kabin amiri veya eğitmen',
            'Bilmiyorum, hayat sürprizlerle dolu',
            'Kendi işimi kurmak istiyorum'
          ],
          correct: 1
        },
        {
          q: 'Mülakat sonunda "Sorularınız var mı?" denilince ne yapmalı?',
          options: [
            'Hayır, teşekkürler demek',
            'Maaşı sormak',
            'Eğitim süreci veya kariyer gelişimi sormak',
            'Tatil günlerini sormak'
          ],
          correct: 2
        }
      ]
    }
  },

  // =============================================================================
  // MODÜL 4: THY MÜLAKAT REHBERİ
  // =============================================================================

  'INT-M4-U1-L1': {
    lesson_id: 'INT-M4-U1-L1',
    title: 'THY Mülakat Süreci',
    type: 'lesson',
    duration: 6,
    xp: 40,
    content: {
      title: '🇹🇷 Türk Hava Yolları Mülakatı',
      paragraphs: [
        'THY, dünyanın en fazla ülkeye uçan havayoludur (120+ ülke). Mülakat süreci son derece rekabetçidir.',
        'AŞAMA 1 - Online Video Mülakat: 5 soru, her soruya 60-90 saniye cevap süresi. İngilizce. Kameraya bakarak doğal konuşun.',
        'AŞAMA 2 - Boy/Kilo Ölçümü: BMI kontrolü, dövme/yara izi incelemesi. Kriterler sıkı uygulanır.',
        'AŞAMA 3 - İngilizce Mülakat: B1-B2 seviye yeterli. Günlük iletişim ve basit e-posta yazabilme beklenir.',
        'AŞAMA 4 - Kurul Mülakatı: CV üzerinden sorular, senaryo soruları, motivasyon değerlendirmesi.',
        'Süreç genelde 4-6 hafta sürer. Başarılı adaylar sağlık kontrolü ve belge tamamlama aşamasına geçer.'
      ],
      keyPoints: [
        'Video mülakat İngilizce - önceden pratik yapın',
        'BMI kriterleri ciddiye alınır',
        'İngilizce B1-B2 seviye yeterli',
        'Rahat sohbet havasında geçiyor'
      ]
    }
  },

  'INT-M4-U1-L2': {
    lesson_id: 'INT-M4-U1-L2',
    title: 'THY\'nin Aradığı Özellikler',
    type: 'interactive',
    duration: 4,
    xp: 35,
    content: {
      title: '🎯 THY Aday Profili',
      intro: 'THY sadece fiziksel kriterlere değil, kişilik ve yetkinliklere de büyük önem verir.',
      challenge: {
        type: 'multipleChoice',
        question: 'THY mülakatında en çok önemsenen özellik?',
        options: [
          { text: 'Fiziksel güzellik', isCorrect: false, feedback: '❌ Düzgün görünüm önemli ama tek kriter değil' },
          { text: 'Yabancı dil sayısı', isCorrect: false, feedback: '❌ İngilizce yeterli, ekstra dil artı puan' },
          { text: 'Takım uyumu ve müşteri odaklılık', isCorrect: true, feedback: '✅ Doğru! THY servis kalitesiyle ünlü' },
          { text: 'Havacılık tecrübesi', isCorrect: false, feedback: '❌ Tecrübesiz adaylar da kabul ediliyor' }
        ]
      },
      facts: [
        { icon: '🤝', title: 'Takım Ruhu', text: 'Uyumlu çalışma becerisi şart' },
        { icon: '💬', title: 'İletişim', text: 'Türkçe ve İngilizce akıcı konuşma' },
        { icon: '🌍', title: 'Kültürel Farkındalık', text: '120+ ülke = çok kültürlü ortam' },
        { icon: '✨', title: 'Profesyonellik', text: 'Görünüm ve davranış kalitesi' }
      ]
    }
  },

  'INT-M4-U2-L1': {
    lesson_id: 'INT-M4-U2-L1',
    title: 'THY Video Mülakat Soruları',
    type: 'lesson',
    duration: 5,
    xp: 40,
    content: {
      title: '🎥 THY Video Mülakat',
      paragraphs: [
        'THY video mülakatında 5 soru sorulur. Her soruya hazırlık süresi + kayıt süresi verilir.',
        'SORU 1: "Tell me about yourself" - Kendinizi 60 saniyede tanıtın. Şu an + geçmiş + neden THY.',
        'SORU 2: "Why do you want to work for Turkish Airlines?" - THY\'nin global ağı, Türk misafirperverliği, kariyer fırsatları vurgulayın.',
        'SORU 3: "Describe a time you dealt with a difficult customer" - STAR tekniği kullanın. Somut örnek verin.',
        'SORU 4: "How do you handle cultural differences?" - Empati, saygı, öğrenme isteği vurgulayın.',
        'SORU 5: "Where do you see yourself in 5 years?" - THY içinde gelişim: kabin amiri, eğitmen, purser hedefi.'
      ],
      keyPoints: [
        'Her soruya hazırlık süresi var',
        'STAR tekniği ile yapılandırılmış cevap',
        'THY\'ye özgü bilgiler kullanın',
        'Doğal ve gülümseyen ifade'
      ]
    }
  },

  'INT-M4-U2-L2': {
    lesson_id: 'INT-M4-U2-L2',
    title: 'THY Senaryo Soruları',
    type: 'scenario',
    duration: 4,
    xp: 40,
    scenario: {
      context: 'THY mülakatı: "Uçuşta bir yolcu alkollü içecek talep ediyor ama zaten sarhoş görünüyor. Ne yaparsınız?"',
      question: 'En profesyonel yaklaşım hangisi?',
      options: [
        { id: 'A', text: 'Kibarca reddedip su/kahve teklif ederim', isCorrect: true },
        { id: 'B', text: 'Veriyorum, müşteri memnuniyeti önemli', isCorrect: false },
        { id: 'C', text: 'Direkt kabin amirine yönlendiririm', isCorrect: false },
        { id: 'D', text: '"Yasal düzenlemeler" diyerek reddederim', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Mükemmel! Uçuş güvenliği her şeyin önünde. Kibarlıkla reddetmek + alternatif sunmak profesyonel yaklaşım.',
        wrong: '❌ Sarhoş yolcuya alkol vermek güvenlik ihlali. Ama kaba reddetmek de yanlış. Profesyonel ve nazik olun.'
      },
      explanation: 'THY mülakatında güvenlik + misafirperverlik dengesi test edilir. Her ikisini de gösterin.'
    }
  },

  'INT-M4-U3-L1': {
    lesson_id: 'INT-M4-U3-L1',
    title: 'THY Kurul Mülakatı',
    type: 'quiz',
    duration: 5,
    xp: 45,
    quiz: {
      questions: [
        {
          q: 'THY\'nin kaç ülkeye uçuş yaptığını biliyor musunuz?',
          options: ['80+ ülke', '100+ ülke', '120+ ülke', '150+ ülke'],
          correct: 2
        },
        {
          q: 'THY\'nin hub\'ı (merkez havalimanı) neresi?',
          options: ['Sabiha Gökçen', 'İstanbul Havalimanı', 'Ankara Esenboğa', 'İzmir Adnan Menderes'],
          correct: 1
        },
        {
          q: 'THY\'nin slogan\'ı nedir?',
          options: ['Fly with us', 'Widen Your World', 'Best in Sky', 'Turkish Hospitality'],
          correct: 1
        },
        {
          q: 'THY kurul mülakatında EN ÖNEMLİ olan?',
          options: [
            'İngilizce mükemmelliği',
            'Samimi, doğal ve takım odaklı olmak',
            'Havacılık bilgisi',
            'Uzun boy'
          ],
          correct: 1
        }
      ]
    }
  },

  // =============================================================================
  // MODÜL 5: PEGASUS MÜLAKAT REHBERİ
  // =============================================================================

  'INT-M5-U1-L1': {
    lesson_id: 'INT-M5-U1-L1',
    title: 'Pegasus Mülakat Süreci',
    type: 'lesson',
    duration: 5,
    xp: 35,
    content: {
      title: '🟡 Pegasus Airlines Mülakatı',
      paragraphs: [
        'Pegasus, Türkiye\'nin en büyük low-cost (düşük maliyetli) havayoludur. Mülakat süreci THY\'den farklıdır.',
        'AŞAMA 1 - Online Başvuru: CV ve kısa sorular. Fiziksel kriterler ön eleme yapılır.',
        'AŞAMA 2 - Online Testler: Bilişsel yetenek testi, kişilik envanteri. Dikkat ve hız önemli.',
        'AŞAMA 3 - Telefon/Video Mülakat: İngilizce seviye kontrolü, motivasyon soruları.',
        'AŞAMA 4 - Assessment Center: Grup aktiviteleri, bireysel mülakat, rol yapma. Genelde Sabiha Gökçen\'de.',
        'Pegasus hızlı büyüyen bir şirket - dinamik, esnek adaylar arıyor.'
      ],
      keyPoints: [
        'Low-cost model = hız ve verimlilik önemli',
        'Online testlerde dikkat ve hız',
        'Esneklik ve adaptasyon vurgulanır',
        'Sabiha Gökçen merkezi'
      ]
    }
  },

  'INT-M5-U1-L2': {
    lesson_id: 'INT-M5-U1-L2',
    title: 'Pegasus Sık Sorulan Sorular',
    type: 'interactive',
    duration: 4,
    xp: 35,
    content: {
      title: '❓ Pegasus Mülakat Soruları',
      intro: 'Pegasus mülakatlarında operasyonel verimlilik ve müşteri memnuniyeti dengesi sorgulanır.',
      challenge: {
        type: 'multipleChoice',
        question: '"Pegasus low-cost havayolu. Bu sizin için ne ifade ediyor?"',
        options: [
          { text: 'Düşük kalite hizmet', isCorrect: false, feedback: '❌ Bu çok yanlış bir tanım!' },
          { text: 'Verimli operasyon ve uygun fiyatlı uçuş', isCorrect: true, feedback: '✅ Low-cost = verimli, düşük kalite değil' },
          { text: 'Daha az çalışmak', isCorrect: false, feedback: '❌ Low-cost daha yoğun tempoda olabilir' },
          { text: 'Sadece iç hatlar', isCorrect: false, feedback: '❌ Pegasus dış hatlara da uçuyor' }
        ]
      },
      facts: [
        { icon: '⚡', title: 'Hızlı Dönüş', text: 'Pegasus\'ta uçak 25 dakikada döner' },
        { icon: '💰', title: 'Verimlilik', text: 'Maliyet optimizasyonu öncelik' },
        { icon: '🎯', title: 'Fiyat/Performans', text: 'Uygun fiyat, iyi hizmet' },
        { icon: '📈', title: 'Büyüme', text: 'Türkiye\'nin en hızlı büyüyen havayolu' }
      ]
    }
  },

  'INT-M5-U2-L1': {
    lesson_id: 'INT-M5-U2-L1',
    title: 'Pegasus Senaryo Soruları',
    type: 'scenario',
    duration: 4,
    xp: 40,
    scenario: {
      context: 'Pegasus mülakatı: "Uçağın 25 dakika içinde tekrar kalkması gerekiyor. Servis henüz bitmedi. Ne yaparsınız?"',
      question: 'Low-cost havayolunda öncelik nedir?',
      options: [
        { id: 'A', text: 'Servisi tamamlamak için zaman istemek', isCorrect: false },
        { id: 'B', text: 'Güvenlik + zamanında kalkış öncelikli, servisi hızlandırmak', isCorrect: true },
        { id: 'C', text: 'Yolculara özür dilemek', isCorrect: false },
        { id: 'D', text: 'Kaptana durumu bildirmek', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Doğru! Low-cost modelde zamanında operasyon kritik. Önce güvenlik, sonra hızlı servis.',
        wrong: '❌ Pegasus\'ta "turnaround time" (dönüş süresi) performans göstergesidir. Verimlilik önemli.'
      },
      explanation: 'Low-cost havayolları dakik operasyona bağımlı. Her gecikme maliyet demek.'
    }
  },

  // =============================================================================
  // MODÜL 6: SUNEXPRESS MÜLAKAT REHBERİ
  // =============================================================================

  'INT-M6-U1-L1': {
    lesson_id: 'INT-M6-U1-L1',
    title: 'SunExpress Mülakat Süreci',
    type: 'lesson',
    duration: 5,
    xp: 35,
    content: {
      title: '☀️ SunExpress Mülakatı',
      paragraphs: [
        'SunExpress, THY ve Lufthansa ortaklığıdır. Tatil destinasyonlarına odaklı charter/scheduled uçuşlar yapar.',
        'AŞAMA 1 - Online Başvuru: İngilizce seviye testi ve yetkinlik envanteri. Grammar, vocabulary, speaking test.',
        'AŞAMA 2 - Yüz Yüze Mülakat: Antalya veya İzmir\'de. 30-45 dakika. İK + kabin ekibi + psikolog.',
        'SunExpress, rahat ve samimi bir mülakat ortamı sunar. "Uçakta görevliymiş gibi" davranmanız beklenir.',
        'Tatil yolcularıyla çalışma deneyimi sorgulanır - neşeli, sabırlı adaylar tercih edilir.'
      ],
      keyPoints: [
        'THY + Lufthansa ortaklığı',
        'Antalya ve İzmir merkezli',
        'Tatil destinasyonları odaklı',
        'Samimi, rahat mülakat ortamı'
      ]
    }
  },

  'INT-M6-U1-L2': {
    lesson_id: 'INT-M6-U1-L2',
    title: 'SunExpress Sık Sorulan Sorular',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        {
          q: 'SunExpress\'in ortakları kimler?',
          options: ['THY + Emirates', 'THY + Lufthansa', 'Pegasus + THY', 'Lufthansa + Emirates'],
          correct: 1
        },
        {
          q: 'SunExpress nereden uçuş yapıyor?',
          options: ['Sadece İstanbul', 'Antalya ve İzmir merkez', 'Sadece Ankara', 'Sadece dış hatlar'],
          correct: 1
        },
        {
          q: 'SunExpress hangi tip yolculara hizmet veriyor?',
          options: ['Sadece iş', 'Tatil yolcuları ağırlıklı', 'Kargo', 'VIP'],
          correct: 1
        },
        {
          q: 'SunExpress mülakatında en önemli özellik?',
          options: ['Ciddiyet', 'Neşeli ve sabırlı olmak', 'Resmiyet', 'Teknik bilgi'],
          correct: 1
        }
      ]
    }
  },

  // =============================================================================
  // MODÜL 7: YABANCI HAVAYOLLARI
  // =============================================================================

  'INT-M7-U1-L1': {
    lesson_id: 'INT-M7-U1-L1',
    title: 'Emirates Mülakat Rehberi',
    type: 'lesson',
    duration: 6,
    xp: 45,
    content: {
      title: '🇦🇪 Emirates Mülakatı',
      paragraphs: [
        'Emirates, dünyanın en prestijli havayollarından biridir. Mülakat süreci son derece rekabetçi - binlerce başvurudan yüzlerce aday alınır.',
        'OPEN DAY formatı: Büyük şehirlerde toplantı salonu. Aynı gün CV tarama + grup aktivite + bireysel mülakat.',
        'AŞAMA 1 - CV Drop: CV\'nizi teslim edin, kısa sohbet. İlk eleme burada yapılır.',
        'AŞAMA 2 - Grup Aktivite: 6-8 kişilik grup tartışması veya problem çözme. Takım uyumu değerlendirilir.',
        'AŞAMA 3 - Bireysel Mülakat: İngilizce mülakat. Motivasyon, deneyim, Dubai\'de yaşama istekliliği.',
        'AŞAMA 4 - Final Mülakat: Üst düzey yönetici ile. Başarılı olursanız sağlık kontrolü ve teklif.'
      ],
      keyPoints: [
        'Open Day formatı - tek gün içinde birden fazla aşama',
        'İngilizce mükemmel olmalı',
        'Dubai\'de yaşamaya hazır olun',
        'Grooming standartları çok yüksek'
      ]
    }
  },

  'INT-M7-U1-L2': {
    lesson_id: 'INT-M7-U1-L2',
    title: 'Emirates Sık Sorulan Sorular',
    type: 'scenario',
    duration: 4,
    xp: 40,
    scenario: {
      context: 'Emirates mülakatı: "Are you willing to relocate to Dubai and live away from your family?"',
      question: 'En doğru cevap yaklaşımı?',
      options: [
        { id: 'A', text: '"Evet ama sık sık eve geleceğim"', isCorrect: false },
        { id: 'B', text: '"Evet, Dubai\'de yaşamak heyecan verici bir fırsat"', isCorrect: true },
        { id: 'C', text: '"Ailemle konuşmam lazım"', isCorrect: false },
        { id: 'D', text: '"Türkiye\'de uçabilir miyim?"', isCorrect: false }
      ],
      feedback: {
        correct: '✅ Emirates adaylarından net bir "evet" bekler. Dubai yaşamına heyecan gösterin.',
        wrong: '❌ Tereddüt veya koşullu cevap Emirates\'te eleme nedenidir.'
      },
      explanation: 'Emirates tüm ekibi Dubai\'de konuşlandırır. Kararlılık ve heyecan göstermelisiniz.'
    }
  },

  'INT-M7-U2-L1': {
    lesson_id: 'INT-M7-U2-L1',
    title: 'Qatar Airways Mülakat Rehberi',
    type: 'lesson',
    duration: 5,
    xp: 40,
    content: {
      title: '🇶🇦 Qatar Airways Mülakatı',
      paragraphs: [
        'Qatar Airways, "World\'s Best Airline" ödüllü premium havayoludur. Doha merkezli.',
        'Mülakat formatı Emirates\'e benzer: Open Day + Assessment Day kombinasyonu.',
        'İlk aşamada SCAR check: Reach test (uzanma), boy ölçümü, görünüm kontrolü.',
        'Grup aktiviteleri: Takım çalışması, problem çözme, kültürel farkındalık senaryoları.',
        'Bireysel mülakatlar: Davranışsal sorular, STAR tekniği beklenir. Doha yaşamı sorgulanır.'
      ],
      keyPoints: [
        'Reach test = 212 cm\'ye uzanabilme',
        '"World\'s Best Airline" ödülünü bilin',
        'Doha yaşamına hazır olun',
        'Kültürel çeşitlilik vurgusu'
      ]
    }
  },

  'INT-M7-U3-L1': {
    lesson_id: 'INT-M7-U3-L1',
    title: 'Diğer Türk Havayolları',
    type: 'lesson',
    duration: 5,
    xp: 35,
    content: {
      title: '🇹🇷 AnadoluJet, Corendon ve Diğerleri',
      paragraphs: [
        'ANADOLUJET: THY\'nin iç hat ve kısa mesafe markası. Mülakat süreci THY\'ye benzer ama daha kısa.',
        'CORENDON: Hollanda merkezli, Antalya odaklı tatil havayolu. Rahat, samimi mülakatlar.',
        'Corendon\'da İngilizce gündelik seviyede yeterli. Neşeli, tatil ruhlu adaylar tercih edilir.',
        'Onur Air ve diğer küçük havayolları benzer süreçler izler - temel İngilizce + CV + mülakat.',
        'Küçük havayolları daha hızlı süreç sunar, rekabet daha düşük olabilir.'
      ],
      keyPoints: [
        'AnadoluJet = THY iştiraki, benzer standartlar',
        'Corendon = tatil odaklı, rahat ortam',
        'Küçük şirketler = daha hızlı süreç',
        'Her şirketi araştırın'
      ]
    }
  },

  // =============================================================================
  // MODÜL 8: AI MÜLAKAT SİMÜLASYONU
  // =============================================================================

  'INT-M8-U1-L1': {
    lesson_id: 'INT-M8-U1-L1',
    title: 'Mülakat Simülasyonu Giriş',
    type: 'lesson',
    duration: 3,
    xp: 25,
    content: {
      title: '🤖 AI Mülakat Pratiği',
      paragraphs: [
        'Bu bölümde yapay zeka destekli mülakat simülasyonu yapacaksınız.',
        'AI size gerçek mülakat soruları soracak ve cevaplarınızı değerlendirecek.',
        'Her soru için detaylı geri bildirim alacaksınız: güçlü yönler, geliştirme alanları.',
        'Pratiği dilediğiniz kadar tekrarlayabilirsiniz. Her tekrar farklı sorular içerebilir.',
        'Simülasyon sırasında STAR tekniğini kullanmayı unutmayın.'
      ],
      keyPoints: [
        'Gerçek mülakat soruları',
        'AI destekli değerlendirme',
        'Detaylı geri bildirim',
        'Sınırsız pratik yapabilirsiniz'
      ]
    }
  },

  'INT-M8-U1-L2': {
    lesson_id: 'INT-M8-U1-L2',
    title: 'AI Mülakat Başlat',
    type: 'ai_interview',
    duration: 15,
    xp: 100,
    aiInterview: {
      mode: 'practice',
      airline: 'general',
      questionCount: 5,
      categories: ['personal', 'behavioral', 'situational'],
      feedbackEnabled: true
    }
  }
};

export const getCabinLessonContent = (lessonId) => {
  return interviewContents[lessonId] || null;
};

export default interviewContents;
